import { lazy } from 'react';

export const LazyHomeFaxPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--home-fax-page" */ './home-fax-page'
    ),
);
